import PageContainer from 'src/pages/components/PageContainer';
import EezyGuardOccurrenceDetail from 'src/pages/components/eezyguard/EezyGuardOccurrenceDetail';
import { isUserCompany } from 'src/utils/auth';

export default function EezyGuardCompanyOccurrenceDetail(): JSX.Element {
  return (
    <PageContainer title="Ocorrência" guard={isUserCompany}>
      <EezyGuardOccurrenceDetail scope="company" />
    </PageContainer>
  );
}
